var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"close-mark",attrs:{"src":_vm.mark,"alt":"Close"}})
}
var staticRenderFns = []

export { render, staticRenderFns }